module.exports = __webpack_public_path__ + "static/media/bgvideo.0c7b132d.jpg";